import { css as cssBase } from "styled-components";
// prevents circular definition since:
// - type for `css` is  ThemedCssFunction<DefaultTheme>
// - theme will be used to define DefaultTheme
export const css = cssBase;
//# sourceMappingURL=common.js.map